import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa"; // Import FaTimes
import { IconContext } from "react-icons/lib";
import { animateScroll as scroll } from "react-scroll";
import {
  Nav,
  NavbarContainer,
  NavItem,
  NavLink,
  NavLogo,
  NavMenu,
  NavBtn,
  NavBtnLink,
  MobileIcon,
  DropdownMenu,
  CloseIcon,
} from "./NavbarElements";
import logo from "../../assets/Ralph_logo.png";

const Navbar = ({ toggle, alwaysBlack = false }) => {
  const [scrollNav, setScrollNav] = useState(alwaysBlack);
  const [isOpen, setIsOpen] = useState(false);

  const changeNav = () => {
    if (alwaysBlack) {
      setScrollNav(true);
      return;
    }
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };

  useEffect(() => {
    if (alwaysBlack) {
      setScrollNav(true);
    }
    window.addEventListener("scroll", changeNav);
  }, [alwaysBlack]);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <IconContext.Provider value={{ color: "#fff" }}>
        <Nav scrollNav={scrollNav}>
          <NavbarContainer>
            <NavLogo to="/" onClick={toggleHome}>
              <img
                src={logo}
                alt="Logo"
                style={{
                  width: 100,
                  height: 50,
                  marginBottom: 16,
                  border: "1px solid #fff",
                }}
              />
            </NavLogo>
            <MobileIcon onClick={toggleDropdown}>
              {isOpen ? <FaTimes /> : <FaBars />}{" "}
              {/* Toggle between FaBars and FaTimes */}
            </MobileIcon>
            <NavMenu>
              <NavItem>
                <NavLink
                  to="about"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  About
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="discover"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Discover
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="team"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Our Team
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="signup"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Sign Up
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="blog"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Blog
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  to="gallery"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Gallery
                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  to="contact"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  Contact
                </NavLink>
              </NavItem>
            </NavMenu>
            <NavBtn>
              <NavBtnLink to="/login">Log In</NavBtnLink>
            </NavBtn>
          </NavbarContainer>
          {isOpen && (
            <DropdownMenu>
              <NavItem>
                <NavLink
                  to="about"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                  onClick={toggleDropdown}
                >
                  About
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="discover"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                  onClick={toggleDropdown}
                >
                  Discover
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="team"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                  onClick={toggleDropdown}
                >
                  Our Team
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="signup"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                  onClick={toggleDropdown}
                >
                  Sign Up
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="blog"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                  onClick={toggleDropdown}
                >
                  Blog
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="gallery"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                  onClick={toggleDropdown}
                >
                  Gallery
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  to="contact"
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                  onClick={toggleDropdown}
                >
                  Contact
                </NavLink>
              </NavItem>
              <NavItem>
                <NavBtn
                  id="dropdownBtn"
                  style={{
                    display: "block",
                    paddingLeft: "12px",
                    paddingTop: "20px",
                  }}
                >
                  <NavBtnLink to="/login">Log In</NavBtnLink>
                </NavBtn>
              </NavItem>
            </DropdownMenu>
          )}
        </Nav>
      </IconContext.Provider>
    </>
  );
};

export default Navbar;
